import { Component, OnInit } from '@angular/core';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GeneralPaymentService } from 'src/app/services/GeneralPayment/general-payment.service';
import { LookupService } from 'src/app/services/Common/lookup.service';


@Component({
  selector: 'app-particular',
  templateUrl: './particular.component.html',
  styleUrls: ['./particular.component.css']
})
export class ParticularComponent implements OnInit {



  Submitted: boolean = false;
  AccList:any;
  ParticularList: any;

  constructor(private generalpaymentService: GeneralPaymentService, public globalHelper: GlobalHelper,
    private spinnerService: Ng4LoadingSpinnerService,private lookupservice: LookupService) { }

  ParticularModel = {
    ParticularID: 0,
    ParticularName: '',
    AccName: '',
    AccID:0,
    IsActive: true
  };

  Clear() {
    this.ParticularModel.ParticularID = 0;
    this.ParticularModel.ParticularName = '';
    this.ParticularModel.AccID = 0;
    this.ParticularModel.IsActive = true;
    this.Submitted = false;
  };

  GetAllParticular() {
    this.spinnerService.show();
    this.generalpaymentService.GetAllParticular().subscribe((response: any) => {
      this.ParticularList = response.ParticularList;
      this.spinnerService.hide();
    });
  };


  SaveParticular(valid) {
    this.Submitted = true;
    if (valid) {
      this.spinnerService.show();
      this.generalpaymentService.SaveParticular(JSON.stringify(this.ParticularModel)).subscribe((data: any) => {
        if (data.webResponse.Status) {        
          this.GetAllParticular();
        }
        if (data.webResponse.Status && this.ParticularModel.ParticularID==0) {
          this.Clear();
          this.GetAllParticular();
        }
        this.globalHelper.CheckActionStatus(data);
        this.spinnerService.hide();
      });
    }
  };

  ParticularMarkActive(item) {
    this.ParticularModel.ParticularID = item.ParticularID;
    this.ParticularModel.IsActive = item.IsActive == true ? false : true;
    this.generalpaymentService.ParticularMarkActive(JSON.stringify(this.ParticularModel)).subscribe((data: any) => {
      if (data.webResponse.Status) {
        this.Clear();
        this.GetAllParticular();
      }
      this.globalHelper.CheckActionStatus(data);
    });

  };

  
  Edit(obj) {

    this.ParticularModel.ParticularID = obj.ParticularID;
    this.ParticularModel.ParticularName = obj.ParticularName;
    this.ParticularModel.AccID = obj.AccID;
    this.ParticularModel.IsActive = obj.IsActive;


  };


  // Init and Lookup

  ngOnInit() {
    this.GetAccount();
    this.GetAllParticular();
  }


  GetAccount() {
    var itembo = {
        'ItemId': 11,
    }
    this.lookupservice.GetLookupsList('Account', JSON.stringify(itembo)).subscribe((data: any) => {
        this.AccList = data.LookupItems;
    });
}

 
}

